import { SpanStyled } from '@app/modules/audit/hooks/useTranscriptionSync';
import React, { memo, useRef } from 'react';
import { createPortal } from 'react-dom';
import { TranscriptonMenuContainer } from './transcription-menu/TranscriptionMenuContainer';

export interface WordProps {
  word: string;
  index: number;
  isHighlighted: boolean;
  onClick: () => void;
  onHover: (e: React.MouseEvent, index: number) => void;
  onLeave: (e: React.MouseEvent) => void;
  menuPosition: { x: number; y: number };
  isHovered: boolean;
  start: number;
  end: number;
}

/**
 * Renders a single word in the transcription with highlight state and hover menu for timestamp navigation.
 */
const WordComponent = memo(
  ({
    word,
    index,
    isHighlighted,
    onClick,
    onHover,
    onLeave,
    menuPosition,
    isHovered,
    start,
    end,
  }: WordProps) => {
    const menuRef = useRef<HTMLDivElement>(null);

    const handleMenuLeave = () => {
      if (menuRef.current) {
        onLeave(new MouseEvent('mouseleave') as unknown as React.MouseEvent);
      }
    };

    return (
      <span key={`word-${index}`} onMouseEnter={(e) => onHover(e, index)} onMouseLeave={onLeave}>
        <SpanStyled $isHighlighted={isHighlighted} onClick={onClick}>
          {word}
        </SpanStyled>
        {isHovered &&
          createPortal(
            <div
              ref={menuRef}
              style={{
                position: 'fixed',
                left: menuPosition.x,
                top: menuPosition.y,
                zIndex: 1000000,
              }}
              onMouseLeave={handleMenuLeave}
            >
              <TranscriptonMenuContainer start={start} end={end} />
            </div>,
            document.body,
          )}
      </span>
    );
  },
);

WordComponent.displayName = 'WordComponent';

export default WordComponent;
